import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './scss/login.scss';
import '../Home/Error/errors.scss';
import { useAuth } from '../../context/AuthContext';
import { API_BASE } from "../config/api";

const Login = () => {
  const _url = API_BASE;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { login, initSession, isAuthenticated } = useAuth();

  const _emailLS = localStorage.getItem('userEmail') || '';
  const [email, setEmail] = useState(_emailLS ? _emailLS : '');
  const [password, setPassword] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  initSession();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const sessionId = sessionStorage.getItem('sessionId') || '';

    if (!email || !password) {
      setAlertMessage("Por favor, llena todos los campos.");
      setShowAlert(true);
      setIsLoading(false);
      return;
    }

    const url = `${_url}/assistant/login`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, sessionId })
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('userEmail', email);
        localStorage.setItem('role', data.role || 'user');
        localStorage.setItem('alias', data.alias || 'user');

        setIsLoading(false);
        login(email);
        navigate('/home', { state: { email } });
      } else {
        if (response.status === 401) {
          const { detail } = await response.json().catch(() => ({ detail: "" }));
          const msg = (typeof detail === "object" && detail?.message) ? detail.message : (detail || "");
          setAlertMessage(msg || "Usuario o contraseña incorrectos.");
        } else if (response.status === 409) {
          setAlertMessage("Ya tienes una sesión activa en otro dispositivo o navegador. Por favor, cierra la sesión anterior para continuar.");
        } else if (response.status === 400) {
          const { detail } = await response.json().catch(() => ({ detail: "" }));
          const msg = (typeof detail === "object" && detail?.message) ? detail.message : (detail || "");
          setAlertMessage(msg || "Datos incompletos. Revisa los campos e intenta de nuevo.");
        } else {
          setAlertMessage("El servicio de autenticación no está disponible. Por favor, inténtalo de nuevo más tarde.");
        }
        setShowAlert(true);
        setIsLoading(false);
      }
    } catch (error) {
      setAlertMessage("No pudimos conectar con el servicio. Revisa tu conexión a internet o contacta al soporte si el problema persiste.");
      setShowAlert(true);
      setIsLoading(false);
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => setShowAlert(false), 6000);
      return () => clearTimeout(timer);
    }
    if (isAuthenticated) {
      login(localStorage.getItem("userEmail"));
      setIsLoading(false);
      navigate('/home', { state: { email: localStorage.getItem("userEmail") } });
    }
  }, [showAlert, isAuthenticated, login, navigate]);

  return (
    <>
      {/* Alert flotante profesional */}
      {showAlert && (
        <div className="login-alert-overlay">
          <div className="login-alert">
            <div className="login-alert__icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
                <path d="M15 9L9 15M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <div className="login-alert__content">
              <div className="login-alert__title">Error de acceso</div>
              <p className="login-alert__message">{alertMessage}</p>
            </div>
            <button className="login-alert__close" onClick={() => setShowAlert(false)} aria-label="Cerrar">
              &times;
            </button>
          </div>
        </div>
      )}

      <div className="login-container">
        <div className="image-container" style={{ backgroundImage: "url('/fondo.jpg')" }}>
          <h1 className="login-title">Bienvenido al asistente de análisis de costos de Grupo Ferreteria</h1>
        </div>

        <div className="login-form">
          <img src="/logoF.png" alt="Logo" className="logo" />
          <form onSubmit={handleSubmit}>
            <input
              id="email"
              placeholder="Usuario"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              id="password"
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? <div className="loader"></div> : 'Iniciar Sesión'}
            </button>

            <div style={{ marginTop: 12 }}>
              <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
